import ArchiveOutlinedIcon from "@mui/icons-material/ArchiveOutlined";
import AssignmentIndOutlinedIcon from "@mui/icons-material/AssignmentIndOutlined";
import ClosedCaptionOutlinedIcon from "@mui/icons-material/ClosedCaptionOutlined";
import ConnectedTvIcon from "@mui/icons-material/ConnectedTv";
import ConnectedTvOutlinedIcon from "@mui/icons-material/ConnectedTvOutlined";
import FitScreenOutlinedIcon from "@mui/icons-material/FitScreenOutlined";
import Grid4x4OutlinedIcon from "@mui/icons-material/Grid4x4Outlined";
import ImageOutlinedIcon from "@mui/icons-material/ImageOutlined";
import ImagesearchRollerOutlinedIcon from "@mui/icons-material/ImagesearchRollerOutlined";
import LocalMoviesOutlinedIcon from "@mui/icons-material/LocalMoviesOutlined";
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";
import PersonSearchOutlinedIcon from "@mui/icons-material/PersonSearchOutlined";
import QrCodeOutlinedIcon from "@mui/icons-material/QrCodeOutlined";
import QueryStatsOutlinedIcon from "@mui/icons-material/QueryStatsOutlined";
import SecurityOutlinedIcon from "@mui/icons-material/SecurityOutlined";
import SubtitlesOutlinedIcon from "@mui/icons-material/SubtitlesOutlined";
import ViewTimelineOutlinedIcon from "@mui/icons-material/ViewTimelineOutlined";
import YouTubeIcon from "@mui/icons-material/YouTube";
import Diversity2Icon from "@mui/icons-material/Diversity2";
import TheatersIcon from "@mui/icons-material/Theaters";
import LockOpenOutlinedIcon from "@mui/icons-material/LockOpenOutlined";
import { SvgIconProps, Tooltip } from "@mui/material";
import React from "react";

import { OrderProductType } from "../../../Core/Api/Types/order-product-type";
import { GetOrderProductReadableType } from "../../../Utils/helpers";

export interface OrderProductIconProps extends SvgIconProps {
  type: OrderProductType;
}

const OrderProductIcon: React.FC<OrderProductIconProps> = ({ type, ...otherProps }) => {
  switch (type) {
    case OrderProductType.AntipiracyInaSignature:
    case OrderProductType.AntipiracyYoutube:
      return (
        <Tooltip title={GetOrderProductReadableType(type)}>
          <SecurityOutlinedIcon {...otherProps} />
        </Tooltip>
      );
    case OrderProductType.CopyDelivery:
    case OrderProductType.FaspexSend:
      return (
        <Tooltip title={GetOrderProductReadableType(type)}>
          <LocalShippingOutlinedIcon {...otherProps} />
        </Tooltip>
      );
    case OrderProductType.DcpReferenceFileSimple:
    case OrderProductType.DcpReferenceFileStitched:
      return (
        <Tooltip title={GetOrderProductReadableType(type)}>
          <LocalMoviesOutlinedIcon {...otherProps} />
        </Tooltip>
      );
    case OrderProductType.ImageConverter:
      return (
        <Tooltip title={GetOrderProductReadableType(type)}>
          <ImageOutlinedIcon {...otherProps} />
        </Tooltip>
      );
    case OrderProductType.InternalProxyTag:
      return (
        <Tooltip title={GetOrderProductReadableType(type)}>
          <ImagesearchRollerOutlinedIcon {...otherProps} />
        </Tooltip>
      );
    case OrderProductType.ManualTasks:
      return (
        <Tooltip title={GetOrderProductReadableType(type)}>
          <AssignmentIndOutlinedIcon {...otherProps} />
        </Tooltip>
      );
    case OrderProductType.Qualify:
      return (
        <Tooltip title={GetOrderProductReadableType(type)}>
          <QueryStatsOutlinedIcon {...otherProps} />
        </Tooltip>
      );
    case OrderProductType.QualityCheck:
      return (
        <Tooltip title={GetOrderProductReadableType(type)}>
          <PersonSearchOutlinedIcon {...otherProps} />
        </Tooltip>
      );
    case OrderProductType.SubtitleConverter:
      return (
        <Tooltip title={GetOrderProductReadableType(type)}>
          <ClosedCaptionOutlinedIcon {...otherProps} />
        </Tooltip>
      );
    case OrderProductType.SubtitleScribeProject:
      return (
        <Tooltip title={GetOrderProductReadableType(type)}>
          <SubtitlesOutlinedIcon {...otherProps} />
        </Tooltip>
      );
    case OrderProductType.TranscodeBundleByProfile:
      return (
        <Tooltip title={GetOrderProductReadableType(type)}>
          <ArchiveOutlinedIcon {...otherProps} />
        </Tooltip>
      );
    case OrderProductType.TranscodeComponentsLegacy:
      return (
        <Tooltip title={GetOrderProductReadableType(type)}>
          <Diversity2Icon {...otherProps} />
        </Tooltip>
      );
    case OrderProductType.TranscodeByProfile:
      return (
        <Tooltip title={GetOrderProductReadableType(type)}>
          <ConnectedTvOutlinedIcon {...otherProps} />
        </Tooltip>
      );
    case OrderProductType.TranscodeDownscaleAsMezz:
      return (
        <Tooltip title={GetOrderProductReadableType(type)}>
          <FitScreenOutlinedIcon {...otherProps} />
        </Tooltip>
      );
    case OrderProductType.TranscodeGeneric:
    case OrderProductType.TranscodeGenericSingleFile:
      return (
        <Tooltip title={GetOrderProductReadableType(type)}>
          <QrCodeOutlinedIcon {...otherProps} />
        </Tooltip>
      );
    case OrderProductType.TranscodeDcp:
    case OrderProductType.TranscodeImf:
    case OrderProductType.TranscodeNormalizer:
      return (
        <Tooltip title={GetOrderProductReadableType(type)}>
          <Grid4x4OutlinedIcon {...otherProps} />
        </Tooltip>
      );
    case OrderProductType.TranscodeSequence:
      return (
        <Tooltip title={GetOrderProductReadableType(type)}>
          <ViewTimelineOutlinedIcon {...otherProps} />
        </Tooltip>
      );
    case OrderProductType.YoutubeChannelDelivery:
      return (
        <Tooltip title={GetOrderProductReadableType(type)}>
          <YouTubeIcon {...otherProps} />
        </Tooltip>
      );
    case OrderProductType.DcpKdmGeneration:
      return (
        <Tooltip title={GetOrderProductReadableType(type)}>
          <LockOpenOutlinedIcon {...otherProps} />
        </Tooltip>
      );
    case OrderProductType.DcpTransferGlobecast:
      return (
        // TODO: change icone
        <Tooltip title={GetOrderProductReadableType(type)}>
          <TheatersIcon {...otherProps} />
        </Tooltip>
      );
  }

  return <ConnectedTvIcon {...otherProps} />;
};

export default OrderProductIcon;
